module.exports = __webpack_public_path__ + "static/media/impactBackground.b9b54ec0.png";